import { NAME } from "./constants";

export const getFocusedContentOrderDetails = (state) => {
  return state.pages.contentDashboard.modalData[NAME].focusedContentOrder;
};

export const getFocusedContentOrderHTMLContents = (state) => {
  return state.pages.contentDashboard.modalData[NAME].htmlContents;
};

export const getFocusedContentOrderLoadingStatus = (state) => {
  return state.pages.contentDashboard.modalData[NAME].isLoading;
};

export const getFocusedContentOrderSubmitLockedStatus = (state) => {
  return state.pages.contentDashboard.modalData[NAME].submitLocked;
};

export const getFocusedContentOrderPublishModalActiveTab = (state) => {
  return state.pages.contentDashboard.modalData[NAME].activeTab;
};

export const getSubmissionStatus = (state) => {
  return state.pages.contentDashboard.modalData[NAME].submissionStatus;
};
